
import { axiosBitrixInstance } from "../../../utils/axios/requestInfo";
import { generateGuid } from "../../../helpers/generateGuid";
import { getMoscowDate } from "../../../helpers/dateFormatter";
import { api } from "../../../resources/api";

export interface BitrixRegisterChildParams {
  partnerId: string;
  profileName: string;
  birthDate: string;
  skipPartnerIdCheck?: boolean;
}

export const bitrixRegisterChild = async (
  partnerId: string,
  profileName: string,
  birthDate: string,
  skipPartnerIdCheck: boolean = false
): Promise<string | number> => {
  const guid = generateGuid({ 
    phone: partnerId, 
    name: profileName, 
    email: birthDate 
  });

  return await axiosBitrixInstance
    .post(
      api.bitrix.CREATE_MODIFY_PARTNER,
      {
        partnerId: partnerId,
        name: profileName,
        birthday: birthDate,
        changeDate: getMoscowDate(),
        guid: guid,
      },
      {
        skipPartnerIdCheck: skipPartnerIdCheck,
      } as any
    )
    .then((response) => {
      return response.data.partnerId;
    })
    .catch((error) => {
      throw error;
    });
};

